export function chooseUnits() {
  const unitsSelect = document.getElementById('choose-units');

  if(unitsSelect) {
    const unitsOptions = unitsSelect.options[unitsSelect.selectedIndex];
    const optionSelected = unitsOptions.value;
    const unitsContainerSelected = document.querySelectorAll('.js-choose-units');

    unitsContainerSelected.forEach((unit) => {
      const dataUnit = unit.getAttribute("data-unit");

      if(dataUnit === optionSelected) {
        unit.classList.add('d-flex');
        unit.classList.remove('d-none');
      } else {
        unit.classList.add('d-none');
        unit.classList.remove('d-flex');
      }
    });

    unitsSelect.addEventListener('change', () => {
      chooseUnits();
    });
  }
}
